module.exports = __webpack_public_path__ + "img/_super_feature_02.e7681ef7.jpg";